// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "Roboto", sans-serif;
}

.App {
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
}

.export-button {
  text-align: end;
  padding: 13px;
}

.expand-header {
  position: relative;
}

.app-padding {
  padding: 20px 20px 300px 20px !important;
}

.group-widget {
  padding: 10px;
}

.group-widget-header.expanded {
  border: 0 !important;
}

.group-widget-header.collapsed {
  border-left: 6px solid currentColor !important;
}

.group-widget-header:hover {
  background: transparent !important;
}

.adjust-height {
  height: auto !important;
}

.rotate {
  transform: rotate(90deg);
}

.rotate:active {
  transform: rotate(90deg) !important;
}

.cell-br-left {
  border-left: 1px solid #c3c6d4;
}

.br-right {
  border-right: 1px solid #c3c6d4;
}

.timer-container {
  border-radius: 10px;
  border: 1px solid rgb(195, 198, 212);
}

.running-colour {
  background-color: rgb(254, 225, 224);
}

.complete-colour {
  background-color: rgb(179, 177, 177);
}

.stop-colour {
  background-color: rgb(222, 222, 226);
}

.default-colour {
  background-color: rgb(255, 255, 255);
}

.timer-box {
  width: 65px;
  text-align: center;
  padding: 6px;
}

.mt-2 {
  margin-top: 5px;
}

.group-widget-header button h5 {
  margin-left: 25px !important;
  text-transform: capitalize;
  color: inherit !important;
}

.group-widget-header button svg {
  position: absolute;
  color: inherit !important;
}

.group-widget-header [class*=" animateIconClose"] {
  transform: rotate(-90deg);
}
.group-widget-header [class*=" animateIconOpen"] {
  transform: rotate(0deg);
}

.group-widget-header [class*=" headerOpen"] {
  border: 0 !important;
  padding: 0;
}

.group-widget-header [class*=" content"] {
  padding: 0 !important;
}

.group-widget-header {
  color: inherit !important;
}

.group-widget-header button:hover {
  background-color: transparent !important;
}

.table-row {
  background-color: transparent !important;
  color: #323232;
}

.table-row:hover {
  background-color: transparent !important;
  color: #323232;
}

.table-cell:hover {
  background-color: transparent !important;
}
.table-cell {
  background-color: transparent !important;
}

.monday-table {
  /* width: 97%; */
  border-left: 6px solid currentColor !important;
}

.user-dropdown {
  position: relative;
  width: 110px;
}

.time-modal {
  color: rgb(202, 197, 197) !important;
}

.note-textarea {
  max-width: 500px;
  max-height: 400px;
  min-width: 500px;
  min-height: 40px;
  border: 1px solid rgb(202, 197, 197) !important;
  border-radius: 10px;
  padding: 5px;
  color: inherit;
  font: inherit;
}

.note-textarea:focus-visible {
  outline: none !important;
  font: inherit;
}

.time-input {
  min-width: 510px;
  min-height: 36px;
  border: 1px solid rgb(202, 197, 197) !important;
  border-radius: 10px !important;
}

.time-input:focus-visible {
  outline: none !important;
}

.group-header {
  margin: 0 0 0 35px;
}

.group-header-button {
  position: absolute;
  right: 51px;
}

.group-header-button-expanded {
  position: absolute;
  top: 0;
}

.group-header-button-collapsed {
  position: absolute;
  top: 20px;
}

.group-content {
  display: contents;
}

.blink {
  animation: blink-animation 1s steps(5, start) infinite;
  -webkit-animation: blink-animation 1s steps(5, start) infinite;
}
@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}

.error-toaster {
  width: 100px !important;
  min-width: 350px !important;
}

.warning-toaster {
  width: 100px !important;
  min-width: 400px !important;
}

@media (min-width: 1685px) {
  .monday-table-body {
    width: 100%;
  }
}
@media (min-width: 1600px) and (max-width: 1680.98px) {
  .monday-table-body {
    width: 99%;
  }
}
@media (min-width: 1550px) and (max-width: 1599.98px) {
  .monday-table-body {
    width: 98%;
  }
}
@media (min-width: 1400px) and (max-width: 1549.98px) {
  .monday-table-body {
    width: 97%;
  }
}
@media (min-width: 1450px) and (max-width: 1499.98px) {
  .monday-table-body {
    width: 96%;
  }
}
@media (min-width: 1400px) and (max-width: 1449.98px) {
  .monday-table-body {
    width: 96%;
  }
}
@media (min-width: 1350px) and (max-width: 1399.98px) {
  .monday-table-body {
    width: 95%;
  }
}
@media (min-width: 1300px) and (max-width: 1349.98px) {
  .monday-table-body {
    width: 94%;
  }
}
@media (min-width: 1250px) and (max-width: 1299.98px) {
  .monday-table-body {
    width: 92%;
  }
}
@media (min-width: 1200px) and (max-width: 1249.98px) {
  .monday-table-body {
    width: 90%;
  }
}
@media (min-width: 1150px) and (max-width: 1199.98px) {
  .monday-table-body {
    width: 89%;
  }
}
@media (min-width: 1100px) and (max-width: 1149.98px) {
  .monday-table-body {
    width: 87%;
  }
}
@media (min-width: 1050px) and (max-width: 1099.98px) {
  .monday-table-body {
    width: 84%;
  }
}
@media (min-width: 1000px) and (max-width: 1049.98px) {
  .monday-table-body {
    width: 82%;
  }
}
@media (min-width: 950px) and (max-width: 999.98px) {
  .monday-table-body {
    width: 80%;
  }
}
@media (min-width: 900px) and (max-width: 949.98px) {
  .monday-table-body {
    width: 77%;
  }
}
@media (min-width: 800px) and (max-width: 899.98px) {
  .monday-table-body {
    width: 72%;
  }
}
@media (min-width: 576px) and (max-width: 767.98px) {
  .monday-table-body {
    width: 40%;
  }
}
@media (max-width: 575.98px) {
  .monday-table-body {
    width: 30%;
  }
}

.timer-font {
  white-space: nowrap;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;EAC/C,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sDAAsD;EACtD,8DAA8D;AAChE;AACA;EACE;IACE,kBAAkB;EACpB;AACF;;AAOA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":["body {\n  margin: 0;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.App {\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.export-button {\n  text-align: end;\n  padding: 13px;\n}\n\n.expand-header {\n  position: relative;\n}\n\n.app-padding {\n  padding: 20px 20px 300px 20px !important;\n}\n\n.group-widget {\n  padding: 10px;\n}\n\n.group-widget-header.expanded {\n  border: 0 !important;\n}\n\n.group-widget-header.collapsed {\n  border-left: 6px solid currentColor !important;\n}\n\n.group-widget-header:hover {\n  background: transparent !important;\n}\n\n.adjust-height {\n  height: auto !important;\n}\n\n.rotate {\n  transform: rotate(90deg);\n}\n\n.rotate:active {\n  transform: rotate(90deg) !important;\n}\n\n.cell-br-left {\n  border-left: 1px solid #c3c6d4;\n}\n\n.br-right {\n  border-right: 1px solid #c3c6d4;\n}\n\n.timer-container {\n  border-radius: 10px;\n  border: 1px solid rgb(195, 198, 212);\n}\n\n.running-colour {\n  background-color: rgb(254, 225, 224);\n}\n\n.complete-colour {\n  background-color: rgb(179, 177, 177);\n}\n\n.stop-colour {\n  background-color: rgb(222, 222, 226);\n}\n\n.default-colour {\n  background-color: rgb(255, 255, 255);\n}\n\n.timer-box {\n  width: 65px;\n  text-align: center;\n  padding: 6px;\n}\n\n.mt-2 {\n  margin-top: 5px;\n}\n\n.group-widget-header button h5 {\n  margin-left: 25px !important;\n  text-transform: capitalize;\n  color: inherit !important;\n}\n\n.group-widget-header button svg {\n  position: absolute;\n  color: inherit !important;\n}\n\n.group-widget-header [class*=\" animateIconClose\"] {\n  transform: rotate(-90deg);\n}\n.group-widget-header [class*=\" animateIconOpen\"] {\n  transform: rotate(0deg);\n}\n\n.group-widget-header [class*=\" headerOpen\"] {\n  border: 0 !important;\n  padding: 0;\n}\n\n.group-widget-header [class*=\" content\"] {\n  padding: 0 !important;\n}\n\n.group-widget-header {\n  color: inherit !important;\n}\n\n.group-widget-header button:hover {\n  background-color: transparent !important;\n}\n\n.table-row {\n  background-color: transparent !important;\n  color: #323232;\n}\n\n.table-row:hover {\n  background-color: transparent !important;\n  color: #323232;\n}\n\n.table-cell:hover {\n  background-color: transparent !important;\n}\n.table-cell {\n  background-color: transparent !important;\n}\n\n.monday-table {\n  /* width: 97%; */\n  border-left: 6px solid currentColor !important;\n}\n\n.user-dropdown {\n  position: relative;\n  width: 110px;\n}\n\n.time-modal {\n  color: rgb(202, 197, 197) !important;\n}\n\n.note-textarea {\n  max-width: 500px;\n  max-height: 400px;\n  min-width: 500px;\n  min-height: 40px;\n  border: 1px solid rgb(202, 197, 197) !important;\n  border-radius: 10px;\n  padding: 5px;\n  color: inherit;\n  font: inherit;\n}\n\n.note-textarea:focus-visible {\n  outline: none !important;\n  font: inherit;\n}\n\n.time-input {\n  min-width: 510px;\n  min-height: 36px;\n  border: 1px solid rgb(202, 197, 197) !important;\n  border-radius: 10px !important;\n}\n\n.time-input:focus-visible {\n  outline: none !important;\n}\n\n.group-header {\n  margin: 0 0 0 35px;\n}\n\n.group-header-button {\n  position: absolute;\n  right: 51px;\n}\n\n.group-header-button-expanded {\n  position: absolute;\n  top: 0;\n}\n\n.group-header-button-collapsed {\n  position: absolute;\n  top: 20px;\n}\n\n.group-content {\n  display: contents;\n}\n\n.blink {\n  animation: blink-animation 1s steps(5, start) infinite;\n  -webkit-animation: blink-animation 1s steps(5, start) infinite;\n}\n@keyframes blink-animation {\n  to {\n    visibility: hidden;\n  }\n}\n@-webkit-keyframes blink-animation {\n  to {\n    visibility: hidden;\n  }\n}\n\n.error-toaster {\n  width: 100px !important;\n  min-width: 350px !important;\n}\n\n.warning-toaster {\n  width: 100px !important;\n  min-width: 400px !important;\n}\n\n@media (min-width: 1685px) {\n  .monday-table-body {\n    width: 100%;\n  }\n}\n@media (min-width: 1600px) and (max-width: 1680.98px) {\n  .monday-table-body {\n    width: 99%;\n  }\n}\n@media (min-width: 1550px) and (max-width: 1599.98px) {\n  .monday-table-body {\n    width: 98%;\n  }\n}\n@media (min-width: 1400px) and (max-width: 1549.98px) {\n  .monday-table-body {\n    width: 97%;\n  }\n}\n@media (min-width: 1450px) and (max-width: 1499.98px) {\n  .monday-table-body {\n    width: 96%;\n  }\n}\n@media (min-width: 1400px) and (max-width: 1449.98px) {\n  .monday-table-body {\n    width: 96%;\n  }\n}\n@media (min-width: 1350px) and (max-width: 1399.98px) {\n  .monday-table-body {\n    width: 95%;\n  }\n}\n@media (min-width: 1300px) and (max-width: 1349.98px) {\n  .monday-table-body {\n    width: 94%;\n  }\n}\n@media (min-width: 1250px) and (max-width: 1299.98px) {\n  .monday-table-body {\n    width: 92%;\n  }\n}\n@media (min-width: 1200px) and (max-width: 1249.98px) {\n  .monday-table-body {\n    width: 90%;\n  }\n}\n@media (min-width: 1150px) and (max-width: 1199.98px) {\n  .monday-table-body {\n    width: 89%;\n  }\n}\n@media (min-width: 1100px) and (max-width: 1149.98px) {\n  .monday-table-body {\n    width: 87%;\n  }\n}\n@media (min-width: 1050px) and (max-width: 1099.98px) {\n  .monday-table-body {\n    width: 84%;\n  }\n}\n@media (min-width: 1000px) and (max-width: 1049.98px) {\n  .monday-table-body {\n    width: 82%;\n  }\n}\n@media (min-width: 950px) and (max-width: 999.98px) {\n  .monday-table-body {\n    width: 80%;\n  }\n}\n@media (min-width: 900px) and (max-width: 949.98px) {\n  .monday-table-body {\n    width: 77%;\n  }\n}\n@media (min-width: 800px) and (max-width: 899.98px) {\n  .monday-table-body {\n    width: 72%;\n  }\n}\n@media (min-width: 576px) and (max-width: 767.98px) {\n  .monday-table-body {\n    width: 40%;\n  }\n}\n@media (max-width: 575.98px) {\n  .monday-table-body {\n    width: 30%;\n  }\n}\n\n.timer-font {\n  white-space: nowrap;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
